<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Tên nhiệm vụ')"
                  v-model.trim="item.missionName"
                  name="className"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('missionName')"
                  :data-vv-as="$t('Tên nhiệm vụ')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="programs"
                  :label="$t('Khung chương trình')"
                  v-model="item.programId"
                  name="programId"
                  item-value="programId"
                  item-text="programName"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('programId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="levelChange(item.programId)"
              />
            </v-flex>
            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nội dung nhiệm vụ thứ 2')"
                  v-model.trim="item.descriptionMonday"
                  name="missionContent"
                  :error-messages="errors.first('descriptionMonday')"
                  :data-vv-as="$t('Nội dung nhiệm vụ thứ 2')"
              />
            </v-flex>
            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nội dung nhiệm vụ thứ 3')"
                  v-model.trim="item.descriptionTuesday"
                  name="missionContent"
                  :error-messages="errors.first('descriptionTuesday')"
                  :data-vv-as="$t('Nội dung nhiệm vụ thứ 3')"
              />
            </v-flex>
            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nội dung nhiệm vụ thứ 4')"
                  v-model.trim="item.descriptionWednesday"
                  name="missionContent"
                  :error-messages="errors.first('descriptionWednesday')"
                  :data-vv-as="$t('Nội dung nhiệm vụ thứ 4')"
              />
            </v-flex>
<!--            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nội dung nhiệm vụ thứ 5')"
                  v-model.trim="item.descriptionThursday"
                  name="missionContent"
                  :error-messages="errors.first('descriptionThursday')"
                  :data-vv-as="$t('Nội dung nhiệm vụ thứ 5')"
              />
            </v-flex>-->
            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nội dung nhiệm vụ thứ 6')"
                  v-model.trim="item.descriptionFriday"
                  name="missionContent"
                  :error-messages="errors.first('descriptionFriday')"
                  :data-vv-as="$t('Nội dung nhiệm vụ thứ 6')"
              />
            </v-flex>
            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nội dung nhiệm vụ thứ 7')"
                  v-model.trim="item.descriptionSaturday"
                  name="missionContent"
                  :error-messages="errors.first('descriptionSaturday')"
                  :data-vv-as="$t('Nội dung nhiệm vụ thứ 7')"
              />
            </v-flex>
<!--            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nội dung nhiệm vụ chủ nhật')"
                  v-model.trim="item.descriptionSunday"
                  name="missionContent"
                  :error-messages="errors.first('descriptionSunday')"
                  :data-vv-as="$t('Nội dung nhiệm vụ chủ nhật')"
              />
            </v-flex>-->
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    units: {
      type: Array,
      default: [],
    },

    programs: {
      type: Array,
      default: [],
    },
  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        missionName: "",
        missionContent: "",
        programID: "",
        descriptionMonday:"",
        descriptionTuesday:"",
        descriptionWednesday:"",
        /*descriptionThursday:"",*/
        descriptionFriday:"",
        descriptionSaturday:"",
        /*descriptionSunday:"",*/
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        //console.log(value);
        if (value !== null) {
          this.item = {
            missionId: value.missionId,
            missionName: value.missionName
                ? value.missionName
                : "",
            programId: value.programId
                ? value.programId
                : "",
            descriptionMonday: value.descriptionMonday
                ? value.descriptionMonday
                : "",
            descriptionTuesday: value.descriptionTuesday
                ? value.descriptionTuesday
                : "",
            descriptionWednesday: value.descriptionWednesday
                ? value.descriptionWednesday
                : "",
/*            descriptionThursday: value.descriptionThursday
                ? value.descriptionThursday
                : "",*/
            descriptionFriday: value.descriptionFriday
                ? value.descriptionFriday
                : "",
            descriptionSaturday: value.descriptionSaturday
                ? value.descriptionSaturday
                : "",
/*            descriptionSunday: value.descriptionSunday
                ? value.descriptionSunday
                : "",*/
            status: value.status ? value.status : 0,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        missionName: "",
        missionContent: "",
        programID: "",
      };
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    clearDropDate() {
      this.item.startDate = '';
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/kidMission/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    // kidLevel
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgram/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.programs = data;
              }
            }
        );
  },
};
</script>
